function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 30px;\n\n  th {\n    background-color: ",
        ";\n  }\n\n  .documents-table path {\n    fill: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React, { PureComponent } from "react";
import styled from "styled-components";
import Table from "../../../../table";
import Link from "../../../../link";
import { MediumText, MutedText } from "../../../../text";
import formatDate from "../../../../../utils/format-date";
import i18n from "../../../../../utils/i18n";
import { FaFilePdf, FaFilePowerpoint, FaImage, FaFileExcel, FaFileWord, FaFile } from "react-icons/fa";
var TableContainer = styled.div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.components.productDetails.rows.documents.tableHeaderBackground;
}, function(param) {
    var theme = param.theme;
    return theme.palette.primary;
});
var DocumentsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(DocumentsComponent, PureComponent);
    var _super = _createSuper(DocumentsComponent);
    function DocumentsComponent() {
        _classCallCheck(this, DocumentsComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.AssetIcon = function(param) {
            var row = param.row;
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
            var fileExtension = (ref = row.attachments) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.meta) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fileName) === null || ref3 === void 0 ? void 0 : ref3.substring(((ref4 = row.attachments) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.meta) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.fileName) === null || ref7 === void 0 ? void 0 : ref7.lastIndexOf(".")) + 1);
            var Icon = function() {
                return /*#__PURE__*/ React.createElement(React.Fragment, null);
            };
            switch(fileExtension){
                case "pdf":
                    Icon = FaFilePdf;
                    break;
                case "pptx":
                    Icon = FaFilePowerpoint;
                    break;
                case "png":
                    Icon = FaImage;
                    break;
                case "xlsx":
                    Icon = FaFileExcel;
                    break;
                case "docx":
                    Icon = FaFileWord;
                    break;
                default:
                    Icon = FaFile;
                    break;
            }
            return /*#__PURE__*/ React.createElement(Link, {
                target: "_blank",
                href: row === null || row === void 0 ? void 0 : (ref8 = row.attachments) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.path
            }, /*#__PURE__*/ React.createElement(Icon, {
                size: "1.5em",
                className: "documents-table"
            }));
        };
        _this.FileName = function(param) {
            var row = param.row;
            var ref, ref1, ref2;
            return /*#__PURE__*/ React.createElement(React.Fragment, null, row === null || row === void 0 ? void 0 : (ref = row.attachments) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.meta) === null || ref2 === void 0 ? void 0 : ref2.fileName);
        };
        _this.columns = [
            {
                id: "asset",
                label: i18n("productDetails.rows.documents.asset"),
                width: "8%",
                textAlign: "center",
                component: _this.AssetIcon
            },
            {
                id: "fileName",
                label: i18n("productDetails.rows.documents.name"),
                component: _this.FileName
            },
            {
                id: "description",
                label: i18n("productDetails.rows.documents.description"),
                width: "20%"
            },
            {
                id: "updatedAt",
                label: i18n("productDetails.rows.documents.lastUpdated"),
                formatter: formatDate("MM/DD/YYYY"),
                width: "20%"
            }, 
        ];
        return _this;
    }
    var _proto = DocumentsComponent.prototype;
    _proto.render = function render() {
        var _props = this.props, row = _props.row, allowHelpText = _props.allowHelpText;
        var label = row.label;
        var data = row.control;
        var helpText = allowHelpText ? row.description : "";
        return /*#__PURE__*/ React.createElement(TableContainer, null, label && /*#__PURE__*/ React.createElement(MediumText, null, label), helpText && /*#__PURE__*/ React.createElement(MutedText, null, helpText), /*#__PURE__*/ React.createElement(Table, {
            keyField: "id",
            columns: this.columns,
            noDataMessage: i18n("productDetails.rows.documents.noDocuments"),
            data: data
        }));
    };
    return DocumentsComponent;
}(PureComponent);
export default DocumentsComponent;
